interface AttachmentIconProps {
  className?: string
  size?: number
}

function AttachmentIcon({ className = '', size = 16 }: AttachmentIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M20.364 11.05 12.95 18.464c-2.343 2.343-6.143 2.343-8.486 0-2.343-2.343-2.343-6.143 0-8.486l7.071-7.071c1.562-1.562 4.095-1.562 5.657 0 1.562 1.562 1.562 4.095 0 5.657l-6.364 6.364c-.781.781-2.047.781-2.828 0-.781-.781-.781-2.047 0-2.828l5.657-5.657'
        stroke='currentColor'
        strokeWidth='1.8'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export { AttachmentIcon }

